import axios from "axios";

export const state = {
    staffattendances: [],
};

export const getters = {
    staffattendances: state => state.staffattendances,
};

export const mutations = {
    setStaffattendances(state, newValue) {
        state.staffattendances = newValue
    },
};

export const actions = {
    fetchStaffattendances({ commit }) {
        axios.get('/staffattendances').then(res => {
            commit('setStaffattendances', res.data.staffattendances);
        })
    },
};
